import React, { useEffect, useState } from "react"
import { Formik } from "formik"
import * as Yup from 'yup'
import axios from 'axios'
import FormAdd from "./FormAdd"
import swal from "sweetalert"
import { useNavigate } from "react-router-dom"


const AddProfile = () => {
  const apiUrl = process.env.REACT_APP_API_URL
  const navigate=useNavigate()

  //set initial values for our form
  const [initValues, setInitValues] = useState({
    firstName: '',
    lastName: '',
    email:'',
    mobile: '',
    DOB: '',
    nationality: '',
    agentId: '',
    status: 'Active',
    emName:'',
    emMobile:'',
    bloodGroup:'',
    paNo: '',
    paIssueDate: '',
    paExpDate: '',
    viExpDate: '',
    viIssueDate: '',
    viStatus: 'Submitted',
    mcRefNo: '',
    mcApprovalDate: '',
    mcValidUntil: '',
    mcStatus: '',
    mcWith: '',
    passportDoc: null,
    visaDoc: null,
    nidDoc: null,
    cidbDoc: null,
    insuranceDoc: null,
  });
  
  //const {loanId, setLoanId} = useContext(LoanContext) //handles loan ID
  const [loading, setLoading] = useState(false) //handles loading page


 // Validate fields using Yup
const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Please fill this field"),
  email: Yup.string()
    .email("Invalid email address"),
  lastName: Yup.string()
    .required("Please fill this field"),
  mobile: Yup.string()
    .required("Please fill this field")
    .matches(/^[0-9]+$/, 'Mobile number must contain only digits'),
  DOB: Yup.string()
    .required("Please fill this field"),
  nationality: Yup.string()
    .required("Please fill this field"),
  status: Yup.string()
    .required("Please fill this field"),
  emName: Yup.string()
    .required("Please fill this field"),
  emMobile: Yup.string()
    .required("Please fill this field")
    .matches(/^[0-9]+$/, 'Emergency contact number must contain only digits')
    .min(9, "Emergency contact number must be at least 9 characters"),
  bloodGroup: Yup.string()
    .required("Please fill this field"),
  paNo: Yup.string()
    .required("Please fill this field"),
  paIssueDate: Yup.string()
    .required("Please fill this field"),
  paExpDate: Yup.string()
    .required("Please fill this field"),
  viIssueDate: Yup.string()
    .required("Please fill this field"),
  viExpDate: Yup.string()
    .required("Please fill this field"),
  viStatus: Yup.string()
    .required("Please fill this field"),
  mcRefNo: Yup.string(),
  mcApprovalDate: Yup.string(),
  mcValidUntil: Yup.string(),
  mcStatus: Yup.string(),
  mcWith: Yup.string(),
  agentId: Yup.string(),
});

  //handle data submission when submit button has been clicked
  const onSubmit = async (data) => {
    setLoading(true)

    try {
      // First, submit the employee data
      const result = await axios.post(`${apiUrl}/employee/add`, data, {
        headers: {
          loginToken: localStorage.getItem("loginToken")
        }
      });

      if(result.status === 200){
        const employeeInfo = result.data.employeeInfo;
        
        // Upload documents if any are selected
        const documentFields = ['passportDoc', 'visaDoc', 'nidDoc', 'cidbDoc', 'insuranceDoc'];
        const documentTitles = {
          passportDoc: 'Passport',
          visaDoc: 'Visa', 
          nidDoc: 'NID',
          cidbDoc: 'CIDB',
          insuranceDoc: 'Insurance'
        };

        for (const field of documentFields) {
          if (data[field] && data[field].size > 0) {
            const fileData = new FormData();
            fileData.append('fileName', documentTitles[field]);
            fileData.append('fileTitle', documentTitles[field]);
            fileData.append('fileAttachment', data[field]);
            fileData.append('employeeId', employeeInfo.id);

            try {
              await axios.post(`${apiUrl}/employee/addFile`, fileData, {
                headers: {
                  loginToken: localStorage.getItem("loginToken")
                }
              });
            } catch (uploadError) {
              console.error(`Failed to upload ${documentTitles[field]}:`, uploadError);
              // Continue with other uploads even if one fails
            }
          }
        }

        setLoading(false);
        swal({
          title: "Success",
          icon: "success",
          text: "Employee added successfully with documents uploaded"
        });
        navigate('/profile');
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (error.response) {
        swal({
          title: "Error",
          icon: "error",
          text: error.response.data.error || "Failed to add employee"
        });
      } else {
        swal({
          title: "Error",
          icon: "error",
          text: "Network error occurred"
        });
      }
    }
  }

  return (
    <div className="flex flex-col w-full items-center justify-center overflow-auto">
      <Formik
        initialValues={initValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {/* form should be wrappped in formik for easy access to formik context variables */}
        <FormAdd initValues={initValues} loading={loading} />
      </Formik>

      {
        //loading && <Loading />
      }
    </div>
  )
}

export default AddProfile
